import { Injectable } from '@angular/core';
import { samlConfiguration } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SsoRedirectService {
  redirectToSso(): void {
    const ssoUrl = samlConfiguration.ssoUrl;
    const defaultRelayState = window.location.href;
    const loginUrl = `${ssoUrl}?RelayState=${encodeURIComponent(defaultRelayState)}`;
    window.location.href = loginUrl;
  }
}
